export default __webpack_public_path__ + "static/media/train.b02d8426.svg";